import { Injectable } from "@angular/core";
import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { EMPTY, Observable, of } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { parseApiResponseArray2, parseApiResponseObject2 } from "@helpers/functions";
import {
	NotificationsCountModel,
	NotificationsIconModel
} from "@modules/notifications/domain/entities/notifications.model";

@Injectable({
	providedIn: "root"
})
export class NotificationsRemote {
	public constructor(private readonly apicallService: ApicallService) {}

	public getCountNotifications$(): Observable<NotificationsCountModel> {
		return this.apicallService.get(`messages/count?seen=false`).pipe(
			map((notificationsCount: NotificationsCountModel) =>
				parseApiResponseObject2<NotificationsCountModel>(notificationsCount)
			),
			// the error is intentionally not handled here
			catchError(() => EMPTY)
		);
	}

	public getIcons$(): Observable<NotificationsIconModel[]> {
		return this.apicallService.get(`events/icons`).pipe(
			map((icons) => parseApiResponseArray2<NotificationsIconModel>(icons)),
			// in order not to break the message endpoint if the icon endpoint is failing, we return null
			catchError(() => of(null))
		);
	}

	public setNotificationsAsSeen$(): Observable<boolean> {
		return this.apicallService.post(`messages/seen`, new ApicallOption(null, { is_seen: true })).pipe(
			// the error is intentionally not handled here
			catchError(() => EMPTY)
		);
	}

	public setNotificationAsRead$(pid): Observable<boolean> {
		const url = `messages/` + pid + `/read`;
		const options = new ApicallOption(null, { is_read: true });
		return this.apicallService.post(url, options).pipe(
			// the error is intentionally not handled here
			catchError(() => EMPTY)
		);
	}
}
